import React from 'react';
import { useTranslation } from 'react-i18next';
import { isLiveStoreUrl, storeLinks } from '../config/storeLinks';
import { CurvedEdge, IconRow, Logo, Section } from './ui';

// width and height are the files' intrinsic sizes, so the space is reserved before they load; CSS sets 48 px tall.
function StoreBadge(props: { url: string; src: string; alt: string; width: number; height: number; notLive: string }) {
  const image = (
    <img className="closing-cta__badge" src={props.src} alt={props.alt} width={props.width} height={props.height} />
  );
  const live = isLiveStoreUrl(props.url);
  return (
    <div className="closing-cta__store">
      {live ? <a href={props.url}>{image}</a> : image}
      {live ? null : <p className="closing-cta__not-live">{props.notLive}</p>}
    </div>
  );
}

// The closing call to action (WU-7), merged with the old Download band. Night surface, curve 3 of 3.
// No QR code until a store URL is live (master plan rule). WU-6 has no phone image yet, so the large mark shows.
const Download: React.FC = () => {
  const { t } = useTranslation();

  const points = [
    { icon: 'shield-check' as const, title: t('cta.points.safe.title'), body: t('cta.points.safe.body') },
    { icon: 'user-check' as const, title: t('cta.points.saved.title'), body: t('cta.points.saved.body') },
    { icon: 'chat' as const, title: t('cta.points.help.title'), body: t('cta.points.help.body') },
  ];

  return (
    <Section
      id="download"
      surface="night"
      className="closing-cta"
      decoration={<CurvedEdge position="top" fill="var(--paper)" />}
    >
      <div className="closing-cta__grid">
        <div className="closing-cta__copy">
          <h2 className="ui-heading">{t('cta.title')}</h2>
          <p className="closing-cta__lead">{t('cta.body')}</p>
          <IconRow tone="onDark" items={points} className="closing-cta__points" />
          <div className="closing-cta__badges">
            <StoreBadge
              url={storeLinks.appStore}
              src="/badges/app-store-badge.svg"
              alt="Download on the App Store"
              width={120}
              height={40}
              notLive={t('download.notLive')}
            />
            <StoreBadge
              url={storeLinks.googlePlay}
              src="/badges/google-play-badge.png"
              alt="Get it on Google Play"
              width={646}
              height={250}
              notLive={t('download.notLive')}
            />
          </div>
        </div>
        <div className="closing-cta__art">
          <Logo size="xl" wordmark={false} decorative />
        </div>
      </div>
    </Section>
  );
};

export default Download;
